import { z } from "zod";

export const ZSessionId = z.object({
  type: z.literal("sessionId"),
  sessionId: z.string(),
});
export type SessionId = z.infer<typeof ZSessionId>;
